import { useTypedNode } from '@rehaje/react'

import { SchemaNode } from '../models/SchemaNode'

export const useSchemaNode = <T extends SchemaNode>(): T | undefined => {
  const node = useTypedNode()
  return (node instanceof SchemaNode ? node : undefined) as T | undefined
}
